export type GameEvents = {
  'coins:changed': { coins: number };
  'secret:collected': { id: string; total: number };
  'furniture:placed': { id: string };
  'furniture:removed': { index: number };
  'mode:enter': { mode: 'play' | 'build' | 'menu' | 'shop' | 'customize' | 'title' };
  'mode:exit': { mode: 'play' | 'build' | 'menu' | 'shop' | 'customize' | 'title' };
  'shop:purchase': { id: string };
  'character:changed': {};
  'toast': { message: string };
  'save:dirty': {};
  'hint:set': { text: string | null };
};

type Handler<K extends keyof GameEvents> = (payload: GameEvents[K]) => void;

class Bus {
  private handlers = new Map<keyof GameEvents, Set<Handler<any>>>();

  on<K extends keyof GameEvents>(event: K, fn: Handler<K>): () => void {
    let set = this.handlers.get(event);
    if (!set) {
      set = new Set();
      this.handlers.set(event, set);
    }
    set.add(fn as Handler<any>);
    return () => set!.delete(fn as Handler<any>);
  }

  emit<K extends keyof GameEvents>(event: K, payload: GameEvents[K]): void {
    const set = this.handlers.get(event);
    if (!set) return;
    for (const fn of set) (fn as Handler<K>)(payload);
  }
}

export const bus = new Bus();
